<a
  *ngIf="!!response"
  jbFocusOn
  firstFocusable="true"
  moveFocusTo="first-tab"
  scroll="true"
  href="javascript:void(0);"
  class="db ph3-ns flex items-center tc ph5 relative flex-column no-underline underline-hover white b"
>
  <div class="z-1 pv5 relative center">
    <span>{{ firstResponseTitle }}</span>
  </div>
</a>
